import {getNextWizardSteps} from "./wizardLogicOld";

export const LEAD_WIZARD_GROUP_TYPES = {
  group: "group",
  filter: "filter",
  custom: "custom",
  inputs: "inputs",
  contact: "contact",
  appointment: "appointment",
  review: "review",
  success: "success",
}

/**
 * this returns new wizard steps depending on the current selection
 * @param wizardActiveItem {wizardItemInterface}
 * @param currentStep {number}
 * @param wizardSelectedValues {object}
 * @returns {object}
 */
export const getLeadFormSteps = (wizardActiveItem, currentStep, wizardSelectedValues) => {
  const wizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, wizardSelectedValues);
  // console.log("wizardSteps", wizardSteps);
  let leadFormSteps = [];
  wizardSteps.forEach(step => {
    if (step.stepGroups.length && step.stepGroups[0].leadStep) {
      let existingLeadStepObject = leadFormSteps.find(leadStepObject => {
        return leadStepObject.leadStepName === step.stepGroups[0].leadStep
      });
      if (!existingLeadStepObject) {
        existingLeadStepObject = {
          leadStepName: step.stepGroups[0].leadStep,
          leadStepUrl: step.stepGroups[0].leadStepUrl,
          leadSubSteps: []
        }
        leadFormSteps.push(existingLeadStepObject);
      }
      existingLeadStepObject.leadSubSteps.push({
        stepIndex: step.stepIndex,
        wizardGroup: step.stepGroups[0], // not needed for now
      });
    }
  })
  // const leadFormSteps = wizardSteps.reduce((total, step) => {
  //   if (step.stepGroups.length && step.stepGroups[0].leadStep && !total.includes(step.stepGroups[0].leadStep)) {
  //     total.push(step.stepGroups[0].leadStep)
  //   }
  //   return total
  // }, []);
  return leadFormSteps
}

/**
 * this returns lowercased url
 * @param leadStepName {string}
 * @returns {string}
 */
export const getUrlLeadStepName = (leadStepName = "") => {
  if (!leadStepName) {
    return ""
  }
  return leadStepName.toLowerCase().replace(/ /g,"-")
}

export const fixStringEncoding = (string) => {
  return string && (typeof string === "string")
    ? string
      .replace("â€�", "”")
      .replace("â€", "”")
      .replace("â€™", "’")
      .replace("â€¨", " ")
      .replace("Ã¢â‚¬Â¨", "") // not sure what it is
    : string
}

export const fixWizardItem = (wizardItem, wizardItemIndex, forLeadForm = false) => {
  wizardItem.wizardNodes = []; // we don't use them in the visualizer! why do we keep them then
  Object.keys(wizardItem).forEach(property => {
    if (typeof wizardItem[property] === "string") {
      wizardItem[property] = fixStringEncoding(wizardItem[property]);
    }
  });
  if (!wizardItem.name) {
    wizardItem.name = "wizard" + (wizardItemIndex > 0 ? "-" + wizardItemIndex + 1 : "");
  }
  const currentVisType = "leadform";
  if (wizardItem.wizardGroups) {
    wizardItem.wizardGroups = wizardItem.wizardGroups.filter(wizGroup => {
      if (!wizGroup.enabled || (wizGroup.hideForCustomers && !document.kvConfig.isBackend)) {
        return false
      }
      if (wizardItem.visualizer === "all") {
        return (wizGroup.groupName === "Room") || !Array.isArray(wizGroup.visibleInVisualizers)
          || !wizGroup.visibleInVisualizers.length || wizGroup.visibleInVisualizers.includes(currentVisType)
      }
      return true
    }).map(wizGroup => {
      if (forLeadForm) {
        //getUrlLeadStepName
        wizGroup.leadStepUrl = wizGroup.leadStep
          ? wizGroup.leadStep.toLowerCase().replace(/ /g,"-")
          : "project"
      }
      if (wizGroup.nodeType === "inputs" && Array.isArray(wizGroup.inputFields)) {
        wizGroup.inputFields = wizGroup.inputFields.filter(inputObject => inputObject.checked)
      }
      Object.keys(wizGroup).forEach(property => {
        if (typeof wizGroup[property] === "string") {
          wizGroup[property] = fixStringEncoding(wizGroup[property]);
        }
      });
      ["featuresIncluded", "featuresExcluded"].forEach(property => {
        if (Array.isArray(wizGroup[property]) && wizGroup[property].length) {
          wizGroup[property] = wizGroup[property].map(excluded => {
            if (excluded && (typeof excluded === "object") && excluded.sharedFeatureName) {
              excluded.sharedFeatureName = excluded.sharedFeatureName
                .trim()
                .toLowerCase()
                .replace('room - ', '')
            }
            return excluded
          })
        }
      });
      return wizGroup
    })
  }
  return wizardItem
}
